Auth = require 'app/scripts/db/auth'
CreateOrgView = require 'app/scripts/views/organization/create-org-view'
PopOver = require 'app/scripts/views/lib/pop-over'
Util = require 'app/scripts/lib/util'
View = require 'app/scripts/views/internal/view'
templates = require 'app/scripts/views/internal/templates'
{ featureFlagClient } = require '@trello/feature-flag-client'

module.exports = class NewBoardHelperAddOrgView extends View
  viewTitleKey: 'add an organization'

  events:
    'click .js-create-org': 'newOrg'

  render: ->
    view = @
    @$el.html(
      templates.fill(
        'popover_helper_new_board_add_org'
      )
    )
    @

  newOrg: (e) ->
    createOpts = {}
    restrictToEnterpriseTeamCreation = featureFlagClient.get(
      'enterprise.prevent-enterprise-paid-members-from-creating-non-enterprise-teams',
      false,
    )
    if restrictToEnterpriseTeamCreation && Auth.me().isManagedEntMember()
      createOpts.isEnterprise = true

    Util.stop(e)
    trackingOpts = { category: 'board', method: 'by clicking team info icon in copy board menu' }
    PopOver.pushView
      view: new CreateOrgView({ @model, @modelCache, createOpts, trackingOpts })
